// cache.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  /**
   * Armazena dados no cache com uma data de expiração.
   * @param key A chave do cache
   * @param data Os dados a serem armazenados
   * @param durationMs A duração do cache em milissegundos
   */
  setCache<T>(key: string, data: T, durationMs: number): void {
    const now = new Date().getTime();
    const cacheData = {
      data,            // Dados a serem armazenados
      timestamp: now,  // Momento de criação do cache
      duration: durationMs // Duração do cache em milissegundos
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
  }

  /**
   * Recupera dados do cache, se ainda não expiraram.
   * @param key A chave do cache
   * @returns Os dados do cache, ou `null` se expirados ou inexistentes
   */
  getCache<T>(key: string): T | null {
    const cachedItem = localStorage.getItem(key);
    if (cachedItem) {
      const { data, timestamp, duration } = JSON.parse(cachedItem);
      const now = new Date().getTime();
      if (now - timestamp < duration) {
        return data;  // Retorna os dados se o cache não expirou
      } else {
        localStorage.removeItem(key);  // Remove o cache expirado
      }
    }
    return null;  // Retorna `null` se não há cache ou se expirou
  }

  /**
   * Remove um cache específico.
   * @param key A chave do cache a ser removido
   */
  clearCache(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Limpa todo o conteúdo do cache no localStorage.
   */
  clearAllCache(): void {
    localStorage.clear();
  }
}
